import { AppDispatch } from "../../redux/store";

interface Product {
  ncmCode: string;
  productId: string;
  id: string;
  partNumber?: string;
  nickname?: string;
}

interface FormBasicInfoUtilsParams {
  pnSimilarSelect: string;
  getSessionId: any;
  pnSimilar: string;
  materialPartNumber: string;
  materialPartDesc: string;
  sessionVerify: any;
  dispatch: AppDispatch;
  setMaterialPartFavError: (error: string) => void;
  setDisplayLoading: (loading: boolean) => void;
  setGetSessionId: (item: Product) => void;
  getDateWithTimezoneOffset: () => string;
  setQuestionsTrue: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorApi: React.Dispatch<React.SetStateAction<boolean>>;
  setModalDisplay: React.Dispatch<React.SetStateAction<boolean>>;
  setOriginalQuestions: React.Dispatch<React.SetStateAction<any[]>>;
  setGetPartNumber: React.Dispatch<React.SetStateAction<string>>;
  sessionProducts: any[];
  setIsBanner: any;
}

const formBasicInfoUtils = {
  handleSimilarProduct: async ({
    pnSimilar,
    sessionProducts,
  }: FormBasicInfoUtilsParams) => {},

  handleConfirmClick: async ({
    pnSimilarSelect,
    getSessionId,
    pnSimilar,
    materialPartNumber,
    materialPartDesc,
    sessionVerify,
    dispatch,
    setMaterialPartFavError,
    setDisplayLoading,
    setGetSessionId,
    getDateWithTimezoneOffset,
    setQuestionsTrue,
    setErrorApi,
    setModalDisplay,
    setOriginalQuestions,
    setGetPartNumber,
    sessionProducts,
    setIsBanner,
  }: FormBasicInfoUtilsParams) => {
    formBasicInfoUtils.handleSimilarProduct({
      pnSimilarSelect,
      getSessionId,
      pnSimilar,
      materialPartNumber,
      materialPartDesc,
      sessionVerify,
      dispatch,
      setMaterialPartFavError,
      setDisplayLoading,
      setGetSessionId,
      getDateWithTimezoneOffset,
      setQuestionsTrue,
      setErrorApi,
      setModalDisplay,
      setOriginalQuestions,
      setGetPartNumber,
      sessionProducts,
      setIsBanner,
    });
  },
};

export default formBasicInfoUtils;
